<template>
  <div class="pages">
      <!-- 头部 -->
      <header class="header">
          <div class="left">
            
          </div>
          <div class="center">
              <img src="../../assets/img/logo-all.png" class="logo" alt="">
            <ul>
                <li :class="{tabOn: isActive}" @click="isActiveFn('isActive')">
                    <router-link :to="{path:'/index'}" class="router"><img v-if="isActive" src="../../assets/img/index-a.png" class="icon" alt=""><img v-else src="../../assets/img/index.png" class="icon" alt="">首页</router-link>
                </li>
                <li :class="{tabOn: isActive2}" @click="isActiveFn('isActive2')">
                    <router-link :to="{path:'/dataQuery'}" class="router"><img v-if="isActive2" src="../../assets/img/ndsj-a.png" class="icon" alt=""><img v-else src="../../assets/img/ndsj.png" class="icon" alt="">数据查询</router-link>
                </li>
                <li :class="{tabOn: isActive3}" @click="isActiveFn('isActive3')">
                    <router-link :to="{path:'/dataReport'}" class="router"><img v-if="isActive3" src="../../assets/img/jdsj-a.png" class="icon" alt=""><img v-else src="../../assets/img/jdsj.png" class="icon" alt="">报表查询</router-link>
                    <!-- <router-link :to="{path:'/statisticalYearbook'}" class="router">统计年鉴</router-link> -->
                </li>
                <li :class="{tabOn: isActive4}" @click="isActiveFn('isActive4')">
                    <router-link :to="{path:'/statisticalInfo'}" class="router"><img v-if="isActive4" src="../../assets/img/wxzl-a.png" class="icon" alt=""><img v-else src="../../assets/img/wxzl.png" class="icon" alt="">文献资料</router-link>
                </li>
            </ul>
          </div>
          <div class="right">
              <ul>
                  <li>
                      <!-- 修改后的设计稿去掉了二维码的显示 -->
                      <!-- <img src="../../assets/img/qrcode.png" alt=""> -->
                  </li>
              </ul>
          </div>
      </header>
      <section class="section">
        <div class="content">
            <!-- <keep-alive> -->
                <router-view></router-view>
            <!-- </keep-alive> -->
        </div>
      </section>  
  </div>
</template>

<script>
export default {
    data() {
        return {
            isActive: true,
            isActive2: false,
            isActive3: false,
            isActive4: false
        }
    },
    computed: {
        //需要监听的数据
        loginpath () {
            return this.$route.path;
        }
    },
     watch:{
        loginpath (path) {
            if (path == '/index') {
            this.isActive = true;
            this.isActive2 = false;
            this.isActive3 = false;
            this.isActive4 = false;
        } else if(path == '/dataQuery'){
            this.isActive = false;
            this.isActive2 = true;
            this.isActive3 = false;
            this.isActive4 = false;
        } else if(path == '/dataReport'){
            this.isActive = false;
            this.isActive2 = false;
            this.isActive3 = true;
            this.isActive4 = false;
        } else if(path == '/reportdetail'){
            this.isActive = false;
            this.isActive2 = false;
            this.isActive3 = true;
            this.isActive4 = false;
        } else if(path == '/article'){
            this.isActive = false;
            this.isActive2 = false;
            this.isActive3 = false;
            this.isActive4 = true;
        } else if(path == '/statisticalInfo'){
            this.isActive = false;
            this.isActive2 = false;
            this.isActive3 = false;
            this.isActive4 = true;
        }
        }
     },
    mounted() {
        //this.$router.push({path: '/index'});
        if (this.$route.path == '/index') {
            this.isActive = true;
            this.isActive2 = false;
            this.isActive3 = false;
            this.isActive4 = false;
        } else if(this.$route.path == '/dataQuery'){
            this.isActive = false;
            this.isActive2 = true;
            this.isActive3 = false;
            this.isActive4 = false;
        } else if(this.$route.path == '/dataReport'){
            this.isActive = false;
            this.isActive2 = false;
            this.isActive3 = true;
            this.isActive4 = false;
        } else if(this.$route.path == '/reportdetail'){
            this.isActive = false;
            this.isActive2 = false;
            this.isActive3 = true;
            this.isActive4 = false;
        } else if(this.$route.path == '/article'){
            this.isActive = false;
            this.isActive2 = false;
            this.isActive3 = false;
            this.isActive4 = true;
        }else if(this.$route.path == '/statisticalInfo'){
            this.isActive = false;
            this.isActive2 = false;
            this.isActive3 = false;
            this.isActive4 = true;
        }
        
    },
    methods: {
        isActiveFn(item) {
            if (item == 'isActive') {
                this.isActive = true;
                this.isActive2 = false;
                this.isActive3 = false;
                this.isActive4 = false;
            } else if(item == 'isActive2'){
                this.isActive = false;
                this.isActive2 = true;
                this.isActive3 = false;
                this.isActive4 = false;
            } else if(item == 'isActive3'){
                this.isActive = false;
                this.isActive2 = false;
                this.isActive3 = true;
                this.isActive4 = false;
            } else if(item == 'isActive4'){
                this.isActive = false;
                this.isActive2 = false;
                this.isActive3 = false;
                this.isActive4 = true;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.pages{
    width: 100%;
    background:rgba(241,245,248,1);
    .header{
        width: 100%;
        height: 84px;
        overflow: hidden;
        box-sizing: border-box;
        position: relative;
        background: linear-gradient(360deg,rgba(193,232,250,0) 0%,rgba(193,232,250,1) 40%);
        // background: url(../../assets/img/headbg.png) 100% 100%;
        // background: linear-gradient(bottom,rgba(1,55,114,1) 0%,rgba(46,120,188,1) 100%);
        position: fixed;
        z-index:1000;
        .left{
            position: absolute;
            left: 20px;
            top: 0;
            height: 100%;
            .text{
                float: left;
                padding: 10px 0;
                overflow: hidden;
                color:rgba(255,255,255,1);
                
                .title{
                    font-size:20px;
                    font-family:PingFangSC;
                    font-weight:100;
                    line-height: 20px;
                    margin: 0;
                    padding-right: 10px;
                    border-right: 1px solid #8EB4D6;
                }
                .subTitle{
                    font-size:12px;
                    margin: 0;
                    width: 80px;
                    padding-right: 10px;
                    border-right: 1px solid #8EB4D6;
                }
            }
        }
        .center{
            margin-top: 50px;
            width: 994px;
            height: 100%;
            margin: 0 auto;
            .logo{
                width: 170px;
                float: left;
                margin: 22px 0;
            }
            ul{
                height: 100%;
                margin: 0;
                padding: 0;
                width: 560px;
                margin-left: 160px;
                display: inline-block;
                li{
                    width: 95px;
                    height: 100%;
                    text-align: center;
                    float: left;
                    cursor: pointer;
                    &:hover{
                       background-image: url(../../assets/img/active-bg.png);
                        background-size:100% 100%; 
                    }
                    
                    .router{
                        display: inline-block;
                        width: 100%;
                        height: 100%;
                        text-align: center;
                        text-decoration: none;
                        color:rgba(32, 49, 75, 1);
                        font-size: 18px; 
                        font-weight:400;
                        line-height: 30px;
                    }
                    .icon{
                        width: 30px;
                        display: block;
                        margin: auto;
                        margin-top: 7px;
                    }
                }
                .tabOn{
                     background-image: url(../../assets/img/active-bg.png);
                     background-size:100% 100%; 
                }
            }
        }
        .right{
            position: absolute;
            right: 20px;
            top: 0;
            // float: right;
            height: 100%;
            ul{
                margin: 0;
                li{
                    width: 50px;
                    height: 100%;
                    text-align: center;
                    float: right;
                    cursor: pointer;
                    &:hover{
                        background: rgb(138, 184, 236);
                    }
                    img{
                        width: 20px;
                        height: 20px;
                        margin: 15px 0;
                    }
                }
            }
        }
    }
    .section{
        width: 100%;
        height: 100%;
        // background: #f1f5f8;
        //background: #E4EFF5;
        background: linear-gradient(360deg,rgba(193,232,250,0) 80%,rgba(193,232,250,1) 100%);
        font-size: 14px;
        color: rgba(0,18,35,1);
        padding-top: 84px;
        // overflow-y: scroll;
        .content{
            width: 100%;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/home/home.vue